import { useNavigate } from "react-router-dom";
import { useData } from "../../state/DataContext"; 

function CourseCard({ img, chapter, title, desc, courseType, id }) {
  const { basicData, advancedData } = useData();
  let iconClass = "bi";
  if (courseType === "basic") iconClass = "bi bi-reception-2";
  else if (courseType === "--") iconClass = "bi bi-reception-3";
  else if (courseType === "advanced") iconClass = "bi bi-reception-4";

  const displayChapter = chapter ? chapter : "CHAPTER";
  const navigate = useNavigate();

  const handleClick = () => {
    const idStr = String(id);
    if (basicData && basicData.find(c => c.id === idStr)) {
      navigate(`/basic?chapterId=${idStr}`);
      return;
    }
    if (advancedData && advancedData.find(c => c.id === idStr)) {
      navigate(`/advanced?chapterId=${idStr}`);
      return;
    }
    console.error("No matching chapter for card id:", idStr);
  };

  return (
    <div className="course-card" onClick={handleClick} style={{ cursor: "pointer" }}>
      <img src={img} alt={title} />
      <div className="course-card-content">
        <div className="course-card-chapter">{displayChapter}</div>
        <div className="course-card-title">{title}</div>
        <div className="course-card-desc">{desc}</div>
        <div className="course-card-level">
          <i className={iconClass}></i> {courseType && courseType.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
export default CourseCard;